const REPLACEABLE_QUERIES: Record<string, string> = {
  pant: 'pants',
}

export const getReplaceableQuery = (query: string) => {
  const transformedQuery = query?.toLowerCase()
  const replaceableQuery = transformedQuery ? REPLACEABLE_QUERIES[transformedQuery] : undefined
  return replaceableQuery || query
}
